import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import {
  Text,
  Button,
} from '@beef/ui-kit';

import { DETALIZATION_MODAL_COMMON } from 'constants/detalization';
import {
  BUTTON_CAPTION,
  COMMON_ERRORS,
} from 'constants/common';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const EmailSection = ({
  email,
  onClick,
  isConfirmed,
}) => (
  <>
    <div className={cx('email-caption-wrapper')}>
      <Text size="size5-b">{DETALIZATION_MODAL_COMMON.SEND_BY_EMAIL}</Text>
    </div>
    <div className={cx('email-wrapper', { 'email-wrapper--confirmed': !isConfirmed })}>
      <div className={cx('email-section-wrapper')}>
        <Text size="size5-r-l">{email || COMMON_ERRORS.NO_EMAIL_ADDRESS}</Text>
        {!isConfirmed && <Text size="size7-m" color="scarlet">Почта не потверждена</Text>}
      </div>
      <div className={cx('email-button-wrapper')}>
        <Button
          variant="plain"
          onClick={onClick}
        >
          <Text size="size5-b">{email ? BUTTON_CAPTION.EDIT : BUTTON_CAPTION.SPECIFY}</Text>
        </Button>
      </div>
    </div>
  </>
);

EmailSection.propTypes = {
  email: PropTypes.string,
  onClick: PropTypes.func,
  isConfirmed: PropTypes.bool,
};
